module.exports = __webpack_public_path__ + "media/images/donation/logo-neobank-49c5c18a51db0a87b90779a73cbb8a1a.jpg";